const mockExams = {
  mockExam: "Mock Test",
  mockExams: "Mock Tests",
  mockExamsImport: "Mock test import",
  creation: "Create mock test",
  update: "Update mock test",
  creationInstruction: "Set the mock test settings",
  noExerciseInMockExam: "No exercises have been added to this mock test yet.",
  mockExamsExplanation:
    "Mock tests are one-time assignments with identical exercises and questions for all students.",
  badColumnsErrors:
    "Incorrect column headers. Expected: UUID, Theme, Level, Number, Name.",
  mockExamsFinding: "The mock test will appear on the “My Assignments” page.",
  isAMockTestWarning: "This is a mock test. It can only be taken once.",
  startMockTest: "Start mock test",
  assignMockTest: "Assign a mock test",
  viewTest: "View student submission",
  copyOf: "{name}’s submission",
  view: "Mock test preview",
};

export default mockExams;
